import { render, staticRenderFns } from "./IssuanceUpload.vue?vue&type=template&id=0280e5a6"
import script from "./IssuanceUpload.vue?vue&type=script&lang=js"
export * from "./IssuanceUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports